(function () {
	'use strict';

	angular
		.module('smb-app')
		.factory('smbDeletedItemsDataStore', [
			'$q',
			'smbDeletedItemsService',
			DeletedItemsDataStore
		]);

	function DeletedItemsDataStore($q, smbDeletedItemsService){
		var _adminTrash;

		return {
			/**
			 * @ngdoc method
			 * @name smbDocumentDataStore#load
			 * @methodOf smb-app.smbDeletedItemsDataStore
			 * @kind function
			 *
			 * @description
			 * Loads the trash for the AirBase deployment.
			 *
			 * @returns {Deferred} Returns a promise that resolves to an object containing admin trash.
			 */
			load: load,
			/**
			 * @ngdoc method
			 * @name smbDocumentDataStore#purge
			 * @methodOf smb-app.smbDeletedItemsDataStore
			 * @kind function
			 *
			 * @description
			 * Permanently deleted the provided item.
			 *
			 * @param {object} purgeddItem The trash item to permanently delete.
			 * @returns {Deferred} Returns a promise that resolves if the deletio nwas successful
			 */
			purge: purge,
			/**
			 * @ngdoc method
			 * @name smbDocumentDataStore#purgeAll
			 * @methodOf smb-app.smbDeletedItemsDataStore
			 * @kind function
			 *
			 * @description
			 * Permanently deleteds all admin trash items in the datastore.
			 *
			 * @returns {Deferred} Returns a promise that resolves if all individual purges succeeded.
			 */
			purgeAll: purgeAll,
			/**
			 * @ngdoc method
			 * @name smbDocumentDataStore#restore
			 * @methodOf smb-app.smbDeletedItemsDataStore
			 * @kind function
			 *
			 * @description
			 * Restores the provided item from the trash.
			 *
			 * @param {object} restoredItem The trash item to restore.
			 * @returns {Deferred} Returns a promise that resolves to a server representation of the restored item.
			 */
			restore: restore,
			/**
			 * @ngdoc property
			 * @name smbDocumentDataStore#adminTrash
			 * @propertyOf smb-app.smbDocumentDataStore
			 * @kind property
			 *
			 * @description
			 * Gets the administratively viewable trash for the deployment.
			 *
			 * @returns {array} Returns a list of deleted admins from the deployment.
			 */
			get adminTrash() { return _adminTrash; }
		};

		function load() {
			return smbDeletedItemsService
				.getAdminTrash()
				.then(function(trash){
					_adminTrash = trash.map(function(t){
						return new DeletedItem(t);
					});

					return _adminTrash;
				});
		}

		function purge(purgedItem) {
			var embedded = purgedItem.__data.Embedded;
			return smbDeletedItemsService
				.purge(embedded.Document || embedded.Folder)
				.then(function(item){
					_adminTrash = _adminTrash.filter(function(t){
						return t.id !== purgedItem.id;
					});

					return purgedItem;
				});
		}

		function restore(restoredItem) {
			return smbDeletedItemsService
				.restore(restoredItem.__data)
				.then(function(item){
					_adminTrash = _adminTrash.filter(function(t){
						return t.id !== restoredItem.id;
					});

					return item;
				});
		}

		function purgeAll() {
			var purgePromises = _adminTrash.map(function(t){
				var embedded = t.__data.Embedded;
				return smbDeletedItemsService.purge(embedded.Document || embedded.Folder);
			});

			return $q.all(purgePromises)
				.then(function(){
					_adminTrash = [];
				});
		}
	}

	function DeletedItem(trash) {
		var isDoc = !!trash.Embedded.Document;
		this.id = isDoc ? trash.Embedded.Document.DocumentId :  trash.Embedded.Folder.FolderId;

		// differentiate folders and documents with shared IDs in the client
		this.id += ('-' + Date.now());

		this.name = getItemName(isDoc, trash);
		this.icon = {
			uri : isDoc ? trash.Links.FolderIconUri : trash.Embedded.Folder.Links.IconUri,
			name : isDoc ? '' : trash.Embedded.Folder.IconName
		};
		this.deleted = trash.DateDeleted;
		this.deletedBy = trash.DeletedByUserName;
		this.__data = trash;
	}

	/**
	 * @private
	 * @description
	 * Helper function that returns the correct name to use based on the item type.
	 *
	 * @param {boolean} isDoc Set to true if the item is a document and false if it is not.
	 * @param {Object} item The item to get the name from.
	 * @returns {string} Returns a string that can be used as the items display name in the trash.
	 */
	function getItemName(isDoc, item) {
		if (!isDoc) {
			return item.ItemName;
		}

		// Truncate any status value from the auto name
		// Statuses are set as tag types that have the prefix &&_AirBase,
		// so find the first instance of this and remove everything after it.
		// We substract 5 from the index so as to remove any trailing pipes as well.
		// This may be unneccessary as well, it looks like status value are not being
		// added to the auto name anymore, this just needs to be confirmed.
		var name = item.Embedded.Document.DocumentAutoName;
		if (name === null) {
			// If there is no autoname, the value will be null,
			// so set it to an empty string, so there are no null reference errors.
			name = '';
		}
		var index = name.indexOf('&&_AirBase_');
		if (index >= 0) {
			name = name.substring(0, index > 0 ? index - 5 : 0);
		}

		return name;
	}
})();


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/deletedItemsDataStore.js
// module id = 118
// module chunks = 1